import React from 'react';
import { Box } from '@mui/material';
import NavbarItem from '../../NaviagtionBar/NavbarItem';

const DefaultNavbarTemplate = ({
  items,
  onItemClick,
  flatNavigationItems
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',  // Changed from 'center' to 'stretch'
        gap: 1,
        height: '100%'  // Added this
      }}
    >
      {items?.filter(item => !item.parentId).map((item) => (
        <NavbarItem
          key={item.id}
          item={item}
          onItemClick={onItemClick}
          horizontalTreeMode={true}
          flatNavigationItems={flatNavigationItems}
        />
      ))}
    </Box>
  );
};

export default DefaultNavbarTemplate;
